const CLOCK_PUBLIC_ORIGIN = "https://busditeads.com";
const CLOCK_LINK_VERSION = "v6";

export function buildClockPath(token: string, source?: string) {
  const params = new URLSearchParams({
    clock_link: CLOCK_LINK_VERSION,
  });

  if (source) {
    params.set("source", source);
  }

  return `/clock/${token}?${params.toString()}`;
}

export function buildClockUrl(token: string) {
  const path = buildClockPath(token);

  if (typeof window === "undefined") {
    return `${CLOCK_PUBLIC_ORIGIN}${path}`;
  }

  const host = window.location.hostname;
  const isPreviewHost = host.includes("id-preview--") || host.includes("lovableproject.com");

  return `${isPreviewHost ? CLOCK_PUBLIC_ORIGIN : window.location.origin}${path}`;
}
